import type { CreateOrderInquiryInput, OrderInquiry } from '@repo/api-contracts';
import { useInvalidateMyOrderInquiries } from '@/entities/order-inquiry';
import { trpc } from '@/shared/api';

/** 접수 뮤테이션 — 성공하면 그 주문의 문의 목록을 무효화한다. 주문 상세 캐시는 바뀌지 않는다(주문 데이터는 그대로). */
export const useCreateOrderInquiry = () => {
  const invalidate = useInvalidateMyOrderInquiries();
  const mutation = trpc.myOrderInquiries.create.useMutation();
  return {
    create: async (input: CreateOrderInquiryInput): Promise<OrderInquiry> => {
      const result = await mutation.mutateAsync(input);
      await invalidate(input.orderId);
      return result;
    },
    isPending: mutation.isPending,
  };
};
